module.exports = __webpack_public_path__ + "img/hio.841c02c8.svg";